import noodleApiClient, { ApiDefinition } from '@noodleApi';
import buildPath from '@tsClient/utilities/buildPath';

const PATH_TEMPLATE = '/creators/{creatorId}/sales-overview';

type ThisApi = ApiDefinition[typeof PATH_TEMPLATE]['GET'];

const getSalesOverview = async ({ creatorId, days }: ThisApi['params'] & ThisApi['query']): Promise<ThisApi['response']> => {
  const path = buildPath<ThisApi>(PATH_TEMPLATE, { creatorId });
  const response = await noodleApiClient.get(path, {
    params: {
      days,
    },
  });
  return response.data;
};

export default getSalesOverview;
